<template>
  <div>
    <template v-if="isMobile">
      <button
        class="header__menu-btn button button_secondary button_circle"
        @click="toggleMenu(true)"
      >
        <span class="button__icon">
          <icon class="header__menu-burger" icon-name='menu'></icon>
        </span>
      </button>
      <div
        class="mobile-menu"
        :class="{'active': mobileMenuOpen}"
        style="display: none"
      >
        <div
          class="mobile-menu__overlay overlay"
          @click="toggleMenu(false)"
        ></div>
        <div class="mobile-menu__container">
          <div class="mobile-menu__header">
            <a class="mobile-menu__logo" :href="this.$getEnvVar('VUE_APP_RR_URL')">
              <img v-if="newYearFeatureEnabled" :src="newYearLogoUrl" alt="RR">
              <img v-else src="@/assets/img/logo.svg" alt="RR">
            </a>
            <div class="mobile-menu__close">
              <button
                class="button button_lg button_square"
                @click="toggleMenu(false)"
              >
              <span class="button__icon">
                <icon icon-name="close"></icon>
              </span>
              </button>
            </div>
          </div>
          <div class="mobile-menu__body">
            <div
              class="mobile-menu__item"
              :class="{'open': item.open}"
              v-for="(item, i) in fullMenu"
              :key="i"
            >
              <div class="divider" v-if="item.isDivider"></div>
              <a
                class="mobile-menu__link"
                :href="!item.items && item.link"
                @click="onMenuClick($event, item)"
                :target="item.blank && '_blank'"
                v-else
              >
              <span class="mobile-menu__link-icon" v-if="item.icon">
                <icon :icon-name="item.icon" w="18" h="18"></icon>
              </span>
                <span v-html="item.name"></span>
                <icon
                  v-if="item.items"
                  class="mobile-menu__link-arrow icon"
                  icon-name="down" w="16" h="16"
                ></icon>
              </a>
              <div class="mobile-menu__subitems" v-if="item.items">
                <div
                  class="mobile-menu__subitem"
                  v-for="(subitem, j) in item.items"
                  :key="j"
                >
                  <a class="mobile-menu__link"
                     :href="subitem.link"
                     :target="subitem.blank && '_blank'"
                  >
                    <span v-html="subitem.name"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div ref="nav" v-else>
      <div
        ref="navContainer"
        class="header-nav"
        :class="{'transparent': !menuUpdated}"
      >
        <div
          class="header-nav__item"
          v-for="(menuItem, i) in menu"
          :key="i"
        >
          <a
            class="header-nav__link"
            :class="menuItem.active && 'active'"
            :href="menuItem.link"
            @click="onNavClick($event, menuItem)"
            :target="menuItem.blank && '_blank'"
            v-html="menuItem.name"
          >
          </a>
        </div>
        <div class="header-nav__item" v-show="menuHidden.length">
          <a class="link link_inherit text-with-icon" href="#" ref="more">
            <span>Ещё</span>
            <icon
              class="icon"
              icon-name="down" w="16" h="16" style="min-width: 16px">
            </icon>
          </a>
          <dropdown
            trigger="more"
            listeners="hover click"
            placement="bottom-end"
          >
            <template slot="items">
              <div
                class="dropdown__item"
                v-for="(menuItem, i) in menuHidden"
                :key="i"
              >
                <a
                  class="dropdown__link"
                  :href="menuItem.link"
                  :target="menuItem.blank && '_blank'"
                >
                  <span class="dropdown__text">{{ menuItem.name }}</span>
                </a>
              </div>
            </template>
          </dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenu',
  props: {
    isMobile: Boolean,
    newYearFeatureEnabled: {
      type: Boolean,
      default: false
    },
    newYearLogoUrl: {
      type: String,
      default: null
    },
    newAppUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      mobileMenuOpen: false,
      menuHidden: [],
      menuItemsWidth: [],
      menuUpdated: false
    }
  },
  computed: {
    menu () {
      return [
        {
          name: 'События',
          link: this.$getEnvVar('VUE_APP_RR_URL') + 'events',
          icon: 'calendar',
          items: [
            { name: 'Предстоящие', link: this.$getEnvVar('VUE_APP_RR_URL') + 'events' },
            { name: 'Идут сегодня', link: this.$getEnvVar('VUE_APP_RR_URL') + 'events?e=1' },
            { name: 'Серии', link: this.$getEnvVar('VUE_APP_RR_URL') + 'events?e=4' },
            { name: 'Виртуальные', link: this.$getEnvVar('VUE_APP_RR_URL') + 'events?e=3' }
          ],
          open: false
        },
        { name: 'Результаты', link: this.$getEnvVar('VUE_APP_RESULTS_URL'), icon: '1st-place-medal' },
        { name: 'Чемпионаты', link: this.$getEnvVar('VUE_APP_CHAMPS_URL'), icon: 'trophy' },
        { name: 'Фото', link: 'https://mysport.photo/', icon: 'camera' },
        { name: 'Клубы', link: '/', icon: 'user-groups', active: true },
        { name: 'Экспо', link: 'https://rrexpo.scount.pro/', icon: 'star', blank: true },
        {
          name: 'Отели',
          link: window.innerWidth < 768 ? 'https://hotels.russiarunning.com/' : 'https://ostrovok.ru/?cur=rub&lang=ru&partner_extra=russiarunning&partner_slug=173962.affiliate.74bf&utm_campaign=ru-ru%2c+deeplink%2c+affiliate&utm_medium=api2&utm_source=173962.affiliate.74bf&utm_term=none&erid=2w5zfjpdz2d',
          icon: 'hotel',
          blank: true
        },
        { name: 'Журнал', link: 'https://new-life.russiarunning.com', icon: 'read' },
        { name: 'Организаторам', link: this.$getEnvVar('VUE_APP_RR_URL') + 'Home/About', icon: 'external-link', blank: true },
        { name: 'Корпоративное участие', link: `https://${this.newAppUrl}/corp-client`, icon: 'external-link', blank: true }
      ]
    },
    mobileMenu () {
      return [
        { isDivider: true },
        { name: 'Личный кабинет', link: this.$getEnvVar('VUE_APP_RR_URL') + 'profile', icon: 'user' },
        { isDivider: true },
        { name: 'Центр поддержки', link: this.$getEnvVar('VUE_APP_RR_URL') + 'support', icon: 'safety-float' },
        { name: 'О платформе', link: this.$getEnvVar('VUE_APP_RR_URL') + 'Home/About', icon: 'rocket' },
        { name: 'Сообщить об&nbsp;ошибке', link: '#', icon: 'bug', action: this.reportBug }
      ]
    },
    fullMenu () {
      return [...this.menu, ...this.mobileMenu]
    }
  },
  methods: {
    reportBug () {
      this.toggleMenu(false)
      if (window.Userback) {
        window.Userback.open()
      }
    },
    onMenuClick (e, item) {
      if (item.items) {
        e.preventDefault()
        item.open = !item.open
        return
      }
      if (item.action) {
        e.preventDefault()
        item.action()
      }
    },
    onNavClick (e, item) {
      if (item.action) {
        e.preventDefault()
        item.action()
      }
    },
    toggleMenu (val) {
      this.mobileMenuOpen = val
    },
    updateNav () {
      if (window.innerWidth < 1024) {
        this.menuUpdated = true
        return
      }

      const { nav } = this.$refs
      const container = this.$refs.navContainer

      if (!container) {
        this.menuUpdated = true
        return
      }

      const availableSpace = nav.offsetWidth
      const widths = this.menuItemsWidth

      if (container.offsetWidth > availableSpace) {
        widths.push(container.offsetWidth)
        const link = this.menu.splice(this.menu.length - 1)
        this.menuHidden.unshift(link[0])
      } else if (availableSpace > widths[widths.length - 1]) {
        const link = this.menuHidden.splice(0, 1)
        this.menu.push(link[0])
        widths.pop()
      }

      this.$nextTick(() => {
        if (container.offsetWidth > availableSpace) {
          this.updateNav()
        }
      })
      this.menuUpdated = true
    },
    checkNav () {
      if (this.isMobile) {
        return
      }

      setTimeout(() => {
        this.updateNav()
        window.addEventListener('resize', this.updateNav)
      }, 10)
    }
  },
  watch: {
    mobileMenuOpen (val) {
      document.body.style.overflow = val ? 'hidden' : ''
    },
    $route () {
      document.body.style.overflow = ''
    }
  },
  mounted () {
    this.checkNav()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/vars";
@import "@/assets/scss/utils/mixins";

.header-nav {
  display: inline-flex;
  align-items: center;
  min-width: 100%;

  &__item {
    margin-right: 20px;

    .link {
      vertical-align: inherit;
    }
  }

  &__link {
    display: block;
    color: inherit;
    font-weight: 600;
    text-decoration: none;
    position: relative;
    padding: 4px 0;
    white-space: nowrap;

    &::before {
      content: "";
      display: block;
      width: 0;
      height: 2px;
      background-image: $gradient-horizontal-primary;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }

    &.active::before,
    .no-touch &:hover::before {
      width: 100%;
      transition: $transition-default;
    }
  }
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  max-width: 100%;
  z-index: 10;
  pointer-events: none;
  display: block !important;

  &.active {
    pointer-events: auto;
  }

  &__overlay {
    opacity: 0;
    transition: $transition-default opacity;

    .mobile-menu.active & {
      opacity: 1;
    }
  }

  &__container {
    position: absolute;
    top: 0;
    left: 0;
    width: 296px;
    max-width: 100%;
    height: 100%;
    background-color: $color-white;
    overflow-x: hidden;
    transform: translateX(-100%);
    transition: $transition-default transform;

    .mobile-menu.active & {
      transform: none;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    margin-bottom: 8px;

    > * {
      flex: 0 0 auto;
    }
  }

  &__body {
    padding: 20px 24px 60px;
  }

  &__logo {
    display: block;
    width: 40px;
    margin: 4px;

    img {
      display: block;
    }
  }

  &__close {
    width: 48px;

    .button {
      position: fixed;
      transform: translateY(-50%);

      &::after {
        content: none;
      }
    }
  }

  &__item {
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }

    .divider {
      margin: -4px 0;
    }
  }

  &__link {
    display: inline-flex;
    vertical-align: top;
    align-items: center;
    color: inherit;
    font-weight: 600;
    text-decoration: none;
  }

  &__link-icon {
    flex: 0 0 auto;
    line-height: 1;
    margin-right: 16px;
  }

  &__link-arrow {
    flex: 0 0 auto;
    line-height: 1;
    margin-left: 4px;
    margin-right: 16px;

    .mobile-menu__item.open & {
      transform: rotate(180deg);
    }
  }

  &__subitems {
    display: none;
    padding-left: 48px;

    .mobile-menu__item.open & {
      display: block;
    }
  }

  &__subitem {
    @include text-sm;
    margin-top: 12px;
  }
}
</style>
